import styled from 'styled-components';
import { Typography } from '../../../global/theme';
import { AlignCenter, FlexBetween } from '../../../global/commonStyle';

const Status = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
  align-items: flex-start;
  border-top: 0.5px solid var(--border-primary);
  padding-top: var(--space-12);
  max-width: 463px;
  width: 100%;
`;

const StatusGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
  width: 100%;
  max-width: 463px;
`;
const Head = styled.div`
  ${FlexBetween}
  background: var(--background-secondary);
  padding: var(--space-4) var(--space-4) var(--space-4) var(--space-8);
  border-radius: var(--border-radius-8);
`;
const SortableStatusWrapper = styled.div<{
  isDragging?: boolean;
  cssTransform?: string;
  cssTransition?: string;
}>`
  transform: ${({ cssTransform }) => cssTransform || 'none'};
  transition: ${({ cssTransition }) => cssTransition || 'none'};
  opacity: ${({ isDragging }) => (isDragging ? 0.4 : 1)};
  width: 100%;
`;

const Bottom = styled.div<{ isDragging?: boolean }>`
  position: relative;
  ${FlexBetween}
  padding: var(--space-4) var(--space-4) var(--space-4) var(--space-8);
  user-select: none;
  background: ${(props) => (props.isDragging ? 'var(--background-primary)' : 'none')};
  border-radius: ${(props) => (props.isDragging ? 'var(--border-radius-8)' : '0')};
  box-shadow: ${(props) => (props.isDragging ? 'var(--shadow-card-hover)' : 'none')};
  border: ${(props) => (props.isDragging ? '0.5px solid var(--border-primary)' : 'none')};

  &:hover {
    background: var(--neutral-secondary);
    border-radius: var(--border-radius-8);
    svg {
      opacity: 1;
    }
  }
  .active-state {
    border-radius: var(--border-radius-6);
    .more-icon {
      background-color: var(--background-muted);
    }
  }
  .more-icon:hover {
    background-color: var(--background-muted);
  }
`;
const Heading = styled.div`
  ${Typography.body_md_medium}
  text-align: left;
  color: var(--text-primary);
`;
const BottomTitle = styled.div`
  ${Typography.body_md_medium}
  text-align: left;
  color: var(--text-primary);
`;
const LeftDiv = styled.div`
  ${AlignCenter}
  gap: var(--space-8);

  .complete-icon {
    path.complete-fill {
      fill: var(--text-tertiary);
    }
  }
`;

const Default = styled.div`
  display: flex;
  align-items: flex-start;
  padding: var(--space-3) var(--space-5);
  ${Typography.body_xs}
  color: var(--text-primary);
  background: var(--background-muted);
  border-radius: var(--border-radius-4);
`;
const Div = styled.div`
  ${AlignCenter}
  gap: var(--space-12);
`;

export { Status, StatusGroup, Head, Heading, Bottom, BottomTitle, LeftDiv, Default, Div, SortableStatusWrapper };
